import React from "react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./sidebar.scss";

function Sidebar() {
  const navigate = useNavigate();

  const handleLogout = () => {
    window.localStorage.removeItem("access_token");
    window.localStorage.removeItem("flag");
  };

  const [currentUrl, setCurrentUrl] = useState(window.location.href);

  useEffect(() => {
    const handleUrlChange = () => {
      setCurrentUrl(window.location.href);
    };

    window.addEventListener("popstate", handleUrlChange);

    return () => {
      window.removeEventListener("popstate", handleUrlChange);
    };
  }, []);

  return (
    <div className="sidebarMain">
      <div className="topLogo">
        <div className="centerLogo" onClick={() => navigate("/")}>
          <div className="logo"></div>
          <div className="name"></div>
        </div>
      </div>
      <div className="listMain">
        <div className="listMainSec">
          <div className="sidebarList">
            <a
              href="/admin/facility"
              style={{
                color: currentUrl.includes("/admin/facility")
                  ? "#FFBF00"
                  : "inherit",
              }}
            >
              Facility
            </a>
            <a
              href="/admin/allbookings"
              style={{
                color: currentUrl.includes("/admin/allbookings")
                  ? "#FFBF00"
                  : "inherit",
              }}
            >
              All Bookings
            </a>
            <a
              href="/admin/members"
              style={{
                color: currentUrl.includes("/admin/members")
                  ? "#FFBF00"
                  : "inherit",
              }}
            >
              Members
            </a>
            <a
              href="/admin/invoice"
              style={{
                color: currentUrl.includes("/admin/invoice")
                  ? "#FFBF00"
                  : "inherit",
              }}
            >
              Invoices
            </a>
            {/* <a
              href="/admin/portfolio"
              style={{
                color: currentUrl.includes("/admin/portfolio")
                  ? "#FFBF00"
                  : "inherit",
              }}
            >
              Portfolios
            </a> */}
            {/* <a
              href="/admin/philanthropy"
              style={{
                color: currentUrl.includes("/admin/philanthropy")
                  ? "#FFBF00"
                  : "inherit",
              }}
            >
              Philanthropy
            </a> */}
            {/* <a
              href="/admin/sponsee"
              style={{
                color: currentUrl.includes("/admin/sponsee")
                  ? "#FFBF00"
                  : "inherit",
              }}
            >
              Sponsee
            </a> */}

            {/* <a
              href="/admin/sponsorship"
              style={{
                color: currentUrl.includes("/admin/sponsorship")
                  ? "#FFBF00"
                  : "inherit",
              }}
            >
              Sponsorship
            </a> */}
            {/* <a
              href="/admin/referral"
              style={{
                color: currentUrl.includes("/admin/referral")
                  ? "#FFBF00"
                  : "inherit",
              }}
            >
              Referrals
            </a> */}
          </div>
          <div className="sidebarListSec">
            <a
              href="/admin/userAccess"
              style={{
                color: currentUrl.includes("/admin/userAccess")
                  ? "#FFBF00"
                  : "inherit",
              }}
            >
              User Access
            </a>
            <a
              href="/admin/update"
              style={{
                color: currentUrl.includes("/admin/update")
                  ? "#FFBF00"
                  : "inherit",
              }}
            >
              Update Password
            </a>
            <a href="/" onClick={handleLogout}>
              Logout
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Sidebar;
